module.exports = __webpack_public_path__ + "static/media/KAYFIK_LOGO.b156ce39.jpg";